import _isEmpty from 'lodash/isEmpty';
import { LOYALTY_CARD_LABELS } from 'constants';
import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  data: null,
  barcode: {
    salt: '',
    loading: false,
    error: null,
  },
  loading: false,
  error: null,
  earnedInCircleLevel: 0,
};

const addCardLabels = (data) => {
  return [...data].map((el) => ({
    ...el,
    cardTypeLabel: LOYALTY_CARD_LABELS[el.cardType],
    cardPreviewLabel: `The ${LOYALTY_CARD_LABELS[el.cardType]}`,
  }));
};

const parseAllCardInfo = (data, isPlcc = true) => {
  return Object.entries(data).reduce((acc, [kiNumber, assets = []]) => {
    return [...acc, ...assets.map((el) => ({ ...el, kiNumber, isPlcc }))];
  }, []);
};

const filterCards = (loyaltyAssets) => loyaltyAssets.filter(({ currentBal }) => currentBal > 0);

const mergeLoyaltyData = (data) => {
  return Object.entries(data.loyaltyAccounts).map(([kiNumber, loyaltyAccountData]) => {
    const loyaltyAccount = loyaltyAccountData instanceof Array ? loyaltyAccountData[0] : loyaltyAccountData; // just for insurance
    if (data.loyaltyAssets[kiNumber]) {
      return {
        kiNumber,
        loyaltyAccount: { ...loyaltyAccount },
        loyaltyAssets: [...addCardLabels(filterCards(data.loyaltyAssets[kiNumber]))],
      };
    }
    return {
      kiNumber,
      loyaltyAccount: { ...loyaltyAccount },
      loyaltyAssets: null,
    };
  });
};

const filterLoyaltyAccounts = (loyaltyAccounts) => loyaltyAccounts.filter((el) => !_isEmpty(el.loyaltyAccount));

const sortMergedAccounts = (arr) => {
  return [...arr].sort(
    (a, b) => parseInt(a.loyaltyAccount.earnedLevel, 10) < parseInt(b.loyaltyAccount.earnedLevel, 10),
  );
};

export const getMaxEarnedInCircleLevel = (loyaltyAccounts) =>
  loyaltyAccounts.reduce((acc, { loyaltyAccount }) => {
    const earnedLevel = parseInt(loyaltyAccount.earnedLevel, 10);
    return earnedLevel > acc ? earnedLevel : acc;
  }, 0);

export const loyalty = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.CLIENT_LOYALTY_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.CLIENT_LOYALTY_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case actionTypes.CLIENT_LOYALTY_SUCCESS:
      if (payload) {
        const loyaltyAccounts = sortMergedAccounts(filterLoyaltyAccounts(mergeLoyaltyData(payload)));
        return {
          ...state,
          loading: false,
          data: {
            loyaltyAccounts,
            loyaltyAssets: filterCards(addCardLabels(parseAllCardInfo(payload.loyaltyAssets))),
            nonPlccAssets: payload.nonPlccAssets
              ? filterCards(addCardLabels(parseAllCardInfo(payload.nonPlccAssets, false)))
              : [],
          },
          earnedInCircleLevel: getMaxEarnedInCircleLevel(loyaltyAccounts),
        };
      }
      return {
        ...state,
        loading: false,
        data: {},
      };

    case actionTypes.CLIENT_LOYALTY_RESET:
      return {
        ...INITIAL_STATE,
        barcode: {
          ...INITIAL_STATE.barcode,
        },
        earnedInCircleLevel: INITIAL_STATE.earnedInCircleLevel,
      };

    case actionTypes.GET_BARCODE_SALT_NUMBER_LOADING:
      return {
        ...state,
        barcode: {
          salt: '',
          error: null,
          loading: true,
        },
      };
    case actionTypes.GET_BARCODE_SALT_NUMBER_SUCCESS:
      return {
        ...state,
        barcode: {
          salt: payload,
          error: null,
          loading: false,
        },
      };
    case actionTypes.GET_BARCODE_SALT_NUMBER_ERROR:
      return {
        ...state,
        barcode: {
          salt: '',
          error: payload,
          loading: false,
        },
      };

    default:
      return state;
  }
};

export default loyalty;
